import { DialogActions, DialogContent } from "@mui/material";
import DialogHESP from "../DialogHESP/DialogHESP";
import DialogFooterWithLoading from "../Loading/DialogFooterWithLoading";

interface Props {
    open: boolean;
    onClose: () => void;
    // datacenterId or deviceContextId
    type: "datacenter" | "device";
    onConfirm: () => void;
}

export default function ConfirmRunBootstrapsDialog({ onClose, onConfirm, open, type }: Props) {
    return (
        <DialogHESP
            title={"Update bootstraps"}
            open={open}
            onClose={onClose}
            content={
                <>
                    <DialogContent>
                        Are you sure you want to update the bootstraps on this{" "}
                        {type === "datacenter" ? "datacenter" : "device context"}?
                    </DialogContent>
                    <DialogActions>
                        <DialogFooterWithLoading
                            isLoading={false}
                            loadingText="Updating..."
                            onCancelClick={onClose}
                            defaultText={"Update"}
                            onActionClick={onConfirm}
                        />
                    </DialogActions>
                </>
            }
        />
    );
}
